<template>
    <div>
        <magazine-list-component :magazineType="'adMagazine'"></magazine-list-component>
        <div class="sub_title pb15 pt15">노출중인 광고매거진 목록</div>
        <el-table :data="exportingMagazineData"  style="width: 100%">
            <el-table-column class="table_no" type="index" label="#" min-width="90" class-name="num text-center"></el-table-column>
            <el-table-column label="제목"  class-name="text_center" prop="am_title" cell="p_title"></el-table-column>
            <el-table-column label="노출기간" max-width="300" class-name="text_center"
                             prop="pc_title" cell="pc_title">
                <template slot-scope="scope">
                    <div>
                        {{ scope.row.am_exposure_sdate }} ~ {{ scope.row.am_exposure_edate }}
                    </div>
                </template>
            </el-table-column>

            <el-table-column
                align="center"
                width="290"
                label=""
                class-name="table_bottons">
                <template slot-scope="scope">
                    <el-button
                        size="mini"
                        type="warning"
                        @click="goDetail(scope.row)">상세</el-button>
                    <el-button
                        size="mini"
                        type="danger"
                        @click="deleteExposureAD(scope.row)">삭제</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>

</template>

<script>
import alertMixins from "@/mixins/alertMixins";
import MagazineListComponent from "@/components/magazine/MagazineListComponent";
import util from "@/mixins/util";
import EventBus from "@/mixins/event-bus";
export default {
    name: "MagazineAdComponent",
    mixins: [alertMixins],
    components: {
        MagazineListComponent
    },
    inject: [],
    provide() {
        return{
            setExposureAD: this.setExposureAD,
            deleteExposureAD: this.openDeleteConfirm
        }
    },
    props: {
    },
    data() {
        return{
            exportingMagazineData: [],
        }
    },
    beforeRouterEnter() {},
    created() {
        this.getExportingMagazine();
    },
    mounted() {
    },
    beforeDestroy() {
    },
    destroyed() {},
    computed: {
    },
    methods:{
        getExportingMagazine() {
            let params = {obt:'am_exposure_date', obs:'asc',};
            this.exportingMagazineData = [];
            try {
                this.$api.$magazine.getExposureAdMagazine(params).then(res => res.Data.Result).then(res => {
                    if(!util.isEmpty(res.List)) {
                        this.exportingMagazineData = res.List;
                    }
                })
            }catch (e) {
                console.log(e)
            }
        },
        tableIdx(index) {
            return this.exportingMagazineData.length - index;
        },
        goDetail(row) {
            this.$router.push(`/magazine/ad/${row.am_idx}`);
        },
        setExposureAD(magazine={}){
            //createExposureAdMagazine api
            if(util.isEmpty(magazine)) {
                this.errorAlert('노출에 실패하였습니다.')
                return false;
            }
            let params = {
                am_idx: magazine.am_idx,
            }
            try {
                this.$api.$magazine.createExposureAdMagazine(params).then(res => res.Data.Result).then(res => {
                    if(res.Info.Type === 1) {
                        this.getExportingMagazine();
                        EventBus.$emit('getMagazine')
                    }else if(res.Info.Type === -1) {
                        this.errorAlert('노출에 실패하였습니다.')
                    }
                })
            }catch (e) {
                console.log(e)
            }
        },
        openDeleteConfirm(magazine) {
            this.createConfirm({
                content: '해당 광고매거진을 미노출 시키겠습니까?',
                confirm: () => {
                    this.deleteExposureAD(magazine)
                }
            })

        },
        deleteExposureAD(magazine) {
            if(util.isEmpty(magazine)) {
                this.errorAlert('미노출에 실패하였습니다.')
                return false;
            }
            let params = {
                am_idx: magazine.am_idx,
            }
            try {
                this.$api.$magazine.deleteExposureAdMagazine(params).then(res => res.Data.Result).then(res => {
                    if(res.Info.Type === 1) {
                        this.getExportingMagazine();
                        EventBus.$emit('getMagazine')
                    }else if(res.Info.Type === -1) {
                        this.errorAlert('미노출에 실패하였습니다.')
                    }
                })
            }catch (e) {
                console.log(e)
            }
        },
    },
    watch: {

    },

}
</script>

<style scoped>

</style>
